import * as React from 'react';

import type { BehaviorSubject } from 'rxjs';

export function useObservableState<T>(subject: BehaviorSubject<T>) {
  const [value, setValue] = React.useState<T>(subject.value);

  React.useEffect(() => {
    const sub = subject.subscribe(v => setValue(v));

    return () => {
      sub.unsubscribe();
    };
  }, [subject]);

  return value;
}
